<template>
    <span>
        <b-button
            v-if="insurance.claim_status.status === 'NOTALLOW'"
            :title="insurance.claim_status.msg"
            disabled
        >
            Open Claim
        </b-button>
        <b-button
            v-else-if="insurance.claim_status.status === 'ALLOW'"
            :title="insurance.claim_status.msg"
            variant="warning"
            @click="handleOpenClaimClick"
        >
            Open Claim
        </b-button>
        <b-button
            v-else
            class="align-baseline"
            title="View Claim"
            variant="primary"
            :href="`/app/damage-protection/claim/edit/${insurance.id}`"
        >
            View Claim
        </b-button>
        <modal
            :id="openClaimConfirmModalID"
            title="Please Confirm"
            ok-title="Continue to Open a Claim"
            @ok="handleOpenClaim"
            @shown="onModalShown"
        >
            Damage protection claims must be opened within 14 days of the guest's departure date.
            You have until {{ get(insurance, 'claim_status.expiration_date', '') }}
            to open an Damage protection claim for this reservation.
            All that is required to open a claim is a description of the accidental damage, who reported
            it and what is being done to do to repair or replace the damaged item(s). Once this claim is
            opened you have 45 days from that day to upload any required receipts, invoices or images to
            complete and submit the claim.
        </modal>
    </span>
</template>

<script>
import get from 'lodash/get';
import Modal from '../../generic/modal/modal.vue';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            insurance: null,
            openClaimConfirmModalID: ''
        };
    },
    created() {
        this.insurance = this.params.data;
        this.openClaimConfirmModalID = `damage-protection-issuances-open-claim-confirm-modal-${this.insurance.id}`;
    },
    methods: {
        get,
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        handleOpenClaim() {
            window.location = `/app/damage-protection/claim/edit/${this.insurance.id}`;
        },
        handleOpenClaimClick() {
            this.$bvModal.show(this.openClaimConfirmModalID);
        }
    }
}
</script>